module.exports = __webpack_public_path__ + "img/img52.53aa2bd7.svg";